export default __webpack_public_path__ + "static/media/the-standard.4e69aa2b.png";